export default __webpack_public_path__ + "static/media/stop-logo-icon.c3fe8236.svg";